import { LoadingOverlay, Box, Group, Button, TextInput } from '@mantine/core';

import { useConfigBaseUrl } from '../hooks/use-config-base-url';

export const BaseUrl = () => {
  const {
    form,
    isLoading,
    handleSubmit,
  } = useConfigBaseUrl();

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Base URL"
          withAsterisk
          key={form.key('baseUrl')}
          {...form.getInputProps('baseUrl')}
        />

        <Group justify="flex-start" mt="30">
          <Button type="submit" loading={isLoading}>
            Сохранить
          </Button>
        </Group>
      </form>
    </Box>
  );
};
